import React, { useState } from 'react';
import { useUploadSignedTransferForms } from '../api/uploadSignedTransferForms';
import { Button, FullScreenSpinner, Spinner } from 'components/Elements';
import { DocumentUploadField, Form } from 'components/Form';
import { useNavigate } from 'react-router-dom';
import { AssignedTo } from './AssignedTo';
import { UPLOADS_URL } from 'config';
import { Check } from 'react-feather';
import { useDueDeligenceAsset } from '../api/getDueDeligenceAsset';

export const UploadSignedTransferForms = ({ id }) => {
  const [signed_transfer_forms, setSignedTransferForms] = useState(null);

  const uploadSignedTransferForms = useUploadSignedTransferForms();

  const assetQuery = useDueDeligenceAsset({ id });

  const navigate = useNavigate();

  if (assetQuery.isLoading) {
    return (
      <div className="w-full h-48 flex justify-center items-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (uploadSignedTransferForms.isLoading) return <FullScreenSpinner />;

  return (
    <div>
      {/* Signed Transfer Forms */}
      {assetQuery.data?.signed_transfer_forms?.document_required &&
        !assetQuery.data?.signed_transfer_forms?.location && (
          <>
            <Form
              id="upload-signed-transfer-forms"
              onSubmit={async () => {
                const bodyFormData = new FormData();
                bodyFormData.append('signed_transfer_forms', signed_transfer_forms);
                await uploadSignedTransferForms.mutateAsync({
                  data: bodyFormData,
                  id: assetQuery.data._id,
                });
                navigate(`/app/due-deligences/${id}/process/success`);
              }}
            >
              {({ register, formState }) => (
                <>
                  <div className="bg-white rounded-2xl shadow-md p-12 mb-4">
                    <div className="text-lg mb-2">Signed Transfer Forms</div>
                    <div className="text-sm mb-3">
                      Lorem ipsum dolor sit amet consectetur. Diam sit rutrum enim dui lectus
                      pharetra consectetur donec gravida. Faucibus quisque dignissim faucibus
                      commodo odio tellus. Proin euismod non eget.
                    </div>
                    <div className="flex flex-row items-center justify-between">
                      <div className="">
                        <DocumentUploadField
                          label="Upload Forms"
                          error={formState.errors['signed_transfer_forms']}
                          onChange={(e) => {
                            setSignedTransferForms(e.target.files[0]);
                          }}
                        />
                      </div>
                      <div className="">
                        <div className="">Assigned to</div>
                        <AssignedTo id={assetQuery.data?.signed_transfer_forms?.assigned_to} />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-end">
                    <Button isLoading={uploadSignedTransferForms.isLoading} type="submit">
                      Submit
                    </Button>
                  </div>
                </>
              )}
            </Form>
          </>
        )}

      {assetQuery.data?.signed_transfer_forms?.location && (
        <div className="bg-white rounded-2xl shadow-md p-8 grid grid-cols-1 md:grid-cols-3 mb-4">
          <div className="">
            <div className="">Signed Transfer Forms</div>
            <a
              href={`${UPLOADS_URL}/documents/due_deligence/${assetQuery.data?.signed_transfer_forms?.location}`}
              target="_blank"
              rel="noreferrer"
              className="text-primary-100"
            >
              {assetQuery.data?.signed_transfer_forms?.location}
            </a>
          </div>
          <div className="">
            <AssignedTo id={assetQuery.data?.signed_transfer_forms?.assigned_to} />
          </div>
          <div className="flex justify-end">
            <div className="rounded-full bg-green-400 p-3 h-12 w-12 flex items-center justify-center">
              <Check size={20} className="text-white" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
